import React, {} from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { Box, IconButton } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ManifestItem from '../manifest-item';
import { EditMode } from '../../../../data/enums';

export interface IManifestBuilderProps {
  fieldsArrayKey: string;
}

export default function ManifestBuilder (props: IManifestBuilderProps) {
  
  const { control } = useFormContext();  
  const { fields, append, remove } = useFieldArray({ name: props.fieldsArrayKey, control  });

  const handleAddButtonClick = () => {
    append({ Category: '', PiiAttributes: ''}); 
  };

  return (
    <Box sx={{ width: '100%', }}>

      {/* Manifest item list */}
      {fields && 
        fields.map((field, index) => (
          <ManifestItem
            key={field.id}
            fieldsArrayKey={props.fieldsArrayKey}
            fieldIndex={index}
            remove={remove}
            mode={EditMode.Add}/>
        ))
      }

      {/* Add new item */}
      <IconButton 
        aria-label="add manifest item"
        onClick={handleAddButtonClick}>
        <AddBoxIcon/>
      </IconButton>

    </Box>
  );
}